import React from 'lib/react';

import { EVGrid, EVTypography } from 'lib/components';
import PropTypes from 'prop-types';

import SRSInfoBannerStyles from './SRSInfoBannerStyles';

export default function SRSInfoBanner({ srsOrgNodeName }) {
  const classes = SRSInfoBannerStyles();
  return (
    <EVGrid className={classes.srsInfoBanner}>
      <EVTypography className={classes.srsInfoText}>{srsOrgNodeName}</EVTypography>
    </EVGrid>
  );
}

SRSInfoBanner.propTypes = {
  srsOrgNodeName: PropTypes.string.isRequired,
};
